module.exports = __webpack_public_path__ + "static/media/planetary_nebula.7ea3266a.png";